import { Container, ContainerModule } from 'inversify';

export const ModulesLoaded = Symbol.for('ModulesLoaded');

export const loadModules = (
  container: Container,
  modules: ContainerModule[],
): void => {
  if (!container.isBound(ModulesLoaded)) {
    container.load(...modules);
    container.bind(ModulesLoaded).toConstantValue(true);
  }
};
